import { defineComponent as s, openBlock as o, createBlock as r, resolveDynamicComponent as a, normalizeClass as n, withCtx as l, renderSlot as u } from "vue";
import { SfLinkVariant as e } from "@storefront-ui/shared";
const f = {
  [e.primary]: "text-primary-700 underline hover:text-primary-800 active:text-primary-900 focus-visible:outline focus-visible:outline-offset focus-visible:rounded-sm",
  [e.secondary]: "underline hover:text-primary-800 active:text-primary-900 focus-visible:outline focus-visible:outline-offset focus-visible:rounded-sm"
}, v = /* @__PURE__ */ s({
  __name: "SfLink",
  props: {
    tag: {
      type: [String, Object],
      default: "a"
    },
    variant: {
      type: String,
      default: e.primary
    }
  },
  setup(t) {
    return (i, c) => (o(), r(a(t.tag), {
      class: n(["focus-visible:outline focus-visible:outline-offset focus-visible:rounded-sm", f[t.variant]]),
      "data-testid": "link"
    }, {
      default: l(() => [
        u(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  v as default
};
